import { selectFromRouteDto } from '../../models';

export default selectFromRouteDto()
  .driverId
  .driver(driver => driver.name.invite(i => i.email.inviteLink.inviteStatusId))
  .toString();
